/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HelloResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Hello<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetHelloFromPositionsDb
   * @request GET:/hello
   * @secure
   */
  getHelloFromPositionsDb = (params: RequestParams = {}) =>
    this.request<HelloResponse, any>({
      path: `/hello`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsHello
   * @request OPTIONS:/hello
   */
  optionsHello = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/hello`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsHello2
   * @request OPTIONS:/hello/{id}
   * @originalName optionsHello
   * @duplicate
   */
  optionsHello2 = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/hello/${id}`,
      method: 'OPTIONS',
      ...params,
    });
}
